import { getYYYYMMDDFormat } from '@utils/dates';

/* eslint-disable import/prefer-default-export */
export const getDSTEndpoint = (goalUID) =>
  `v1/uplus/daily_scholarship_test_details/${
    goalUID ? `?goal_uid=${goalUID}` : ''
  }`;

export const getLeaderboardEndpoint = (goalUID, date, lastKey = '') => {
  return `scholarship/v1/${goalUID}/leaderboard?date=${getYYYYMMDDFormat(
    new Date(date),
    '-'
  )}&limit=20&lastKey=${lastKey}`;
};
